const getErrorAnalytics = (step, { isSemu, replacementReason }) => {
    const analytics = {
        messageType: isSemu ? 'semu' : 'nonsemu',
        pageFunction: 'replace your card',
        pageSubFunction: (replacementReason === null || replacementReason === void 0 ? void 0 : replacementReason.replace('-', ' ')) || '',
        pageKind: 'account services'
    };
    switch (step) {
        case 'ReasonSelection': {
            return Object.assign(Object.assign({}, analytics), { errorMessage: 'Please make a selection', pageName: 'situation selection:error' });
        }
        case 'SelectAccount': {
            return Object.assign(Object.assign({}, analytics), { errorMessage: 'Please select one or more cardholders', pageName: 'cardholder selection:error' });
        }
        default:
            return null;
    }
};
export default getErrorAnalytics;
//# sourceMappingURL=getErrorAnalytics.js.map